import { Injectable } from '@angular/core';
import { IBid, Bid } from '../models/IBid';
import { IBidResponse } from '../models/IBidResponse'
import { Observable } from 'rxjs/Observable';
 
@Injectable()
export class RouteDataService {
  //this service is used to pass data from the request to the response page.
  routedBidResponseValue: Observable<IBidResponse> = Observable.of(null);
  routedBidRequestValue: Observable<IBid> =  Observable.of(null);

  constructor() {
  }

  public clear() {
    this.routedBidResponseValue = Observable.of(null);
    this.routedBidRequestValue = Observable.of(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/routedata.services.ts